import { createEvent, createStore, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import { gatewayBlockChanged } from '../blockGateway'
import { ClientGateway, ClientGatewayResponse } from '../types'
import { GatewayListLoadPayload } from './types'
import { toGatewaysRequest } from './utils'

export const clientGatewaysLoad = createEvent<GatewayListLoadPayload>()

export const getClientGatewaysFx = fx<void, ClientGatewayResponse>({
  method: 'GET',
})

export const $gateways = createStore<ClientGateway[]>([]).on(
  getClientGatewaysFx.doneData,
  (_, response) => response.body.items,
)

export const $total = createStore<number>(0).on(
  getClientGatewaysFx.doneData,
  (_, response) => response.body.total,
)

// The refetch has no access to the component's filters, so the last request
// is kept here.
const $lastGatewaysRequest = createStore<GatewayListLoadPayload | null>(
  null,
).on(clientGatewaysLoad, (_, payload) => payload)

sample({
  clock: clientGatewaysLoad,
  filter: ({ clientId }) => Boolean(clientId),
  fn: toGatewaysRequest,
  target: getClientGatewaysFx,
})

sample({
  clock: gatewayBlockChanged,
  source: $lastGatewaysRequest,
  filter: (request): request is GatewayListLoadPayload =>
    Boolean(request?.clientId),
  fn: toGatewaysRequest,
  target: getClientGatewaysFx,
})

sample({
  clock: getClientGatewaysFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
